import { useState, useEffect, useRef } from "react";
import AirMilestoneManage from "./air-milestone-manage";
import OceanMilestoneManage from "./ocean-milestone-manage";
import { axiosInstance } from "../../utility/apiInstance";
import { GROUND_STAFF, SelectOption } from "./type";
import ServiceTypeToggle from "../../components/shared/ServiceTypeToggle";

export default function MilestoneManage() {
  const scrollContainerRef = useRef<HTMLDivElement | null>(null);
  const [isFixed, setIsFixed] = useState(false);

  const [groundStaffs, setGroundStaffs] = useState<GROUND_STAFF[]>([]);
  const [isGroundStaffsLoaded, setIsGroundStaffsLoaded] = useState(false);
  
    const [activeTab, setActiveTab] = useState<"air" | "ocean">("air");



  const getGroundStaffs = async () => {
    try {
      setIsGroundStaffsLoaded(false);
      const { data } = await axiosInstance.get("/api/v1/customers-auth/customer-staffs");
      setGroundStaffs(data?.data || [])
    } catch (error) {
      setGroundStaffs([]);
    } finally {
      setIsGroundStaffsLoaded(true);
    }
  }
  const groundStaffOptions: SelectOption[] = groundStaffs.map(gs => ({
    label: gs.name,
    value: gs._id,
  }));

  useEffect(() => {
    getGroundStaffs()
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsFixed(true);
      } else {
        setIsFixed(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);


  return (
    <div className=" ">
      {/* ── Sticky header bar ─────────────────────────────────── */}
      <div
        className="fiexddBox"
        ref={scrollContainerRef}
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          backgroundColor: isFixed ? "white" : "transparent",
          padding: "8px 10px",
          transition: "background-color 0.3s ease",
          position: isFixed ? "sticky" : "relative",
          top: isFixed ? "0px" : "auto",
          left: "0",
          right: "0",
          margin: "0 auto 10px",
          zIndex: 1,
          boxShadow: isFixed ? "0px 2px 4px rgba(0,0,0,0.1)" : "none",
          borderRadius: isFixed ? "15px" : "0px",
        }}
      >
        {/* Left — page title */}
        <h1
          style={{
            fontSize: "20px",
            fontWeight: 700,
            color: "#374151",
            margin: 0,
            lineHeight: 1,
            width: "75%",
            zIndex: 1
          }}
        >
          Milestone Management
        </h1>
        {/* Right — toggle */}
        <ServiceTypeToggle
          onTypeChange={setActiveTab}
          activeTab={activeTab}
          width="25%"
        />
      </div>

      {activeTab === "air" && <AirMilestoneManage groundStaffOptions={groundStaffOptions} />}
      {activeTab === "ocean" && <OceanMilestoneManage groundStaffOptions={groundStaffOptions} />}

    </div>
  );
}
